import {
  children as solidChildren,
  createMemo,
  EffectFunction,
  getOwner,
  useContext as solidUseContext,
} from "solid-js";

namespace USolid {
  // For use when destructuring children, children helper name will collide
  export const children = solidChildren;
  // useContext is a useful name in namespaces, use this when name collides
  export const useContext = solidUseContext;

  export const runMemo = <T,>(fn: EffectFunction<T>, initialValue?: any) => {
    const owner = getOwner();
    return owner ? createMemo(fn, initialValue)() : fn(initialValue);
  };
}

export default USolid;
